import { render, staticRenderFns } from "./FormParameter.vue?vue&type=template&id=1f54a8b9&"
import script from "./FormParameter.vue?vue&type=script&lang=js&"
export * from "./FormParameter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports